<template>
  <div>
    <v-row>
      <v-col cols=12>
        <upload-area 
          @files:change="filesChange"
          :extensoesPermitidas="extensoesPermitidas"
        />
      </v-col>
    </v-row>
      <general-progress-bars
        class="mt-11 mb-11"
        :items="uploadProgressData"
        prefixText="Enviando"
        suffixProperty="name"
        :includeHashOnText="false"
        :truncateText="true"
      />
      <upload-queue 
        :files.sync="files"
        :uploadProgressData.sync="uploadProgressData"
        :functionServiceUpload="customFunctionUpload"
        @file:uploaded="handleFileUploaded"
        :extra="parametroExtra"
        :caminhoTmp="caminhoTmp"
      />
  </div>
</template>

<script>
export default {
  props: {
    customFunctionUpload: {
      type: Function,
      required: false
    },
    extensoesPermitidas: {
      type: Array,
      default: () => ['*']
    },
    parametroExtra:{
      type: Number,
      required: false
    },
    caminhoTmp: {
      type: String,
      default: null,
    }
  },
  
  components: {
    UploadArea:  () => import('@/components/general/UploadFiles/UploadArea.vue'),
    UploadQueue: () => import('@/components/general/UploadFiles/UploadQueue.vue'), 
    GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue')
  },

  data: () => ({
    files: [],
    uploadProgressData: {},
    uploadedFiles: [],  
  }),

  methods: {
    filesChange(file) {
      this.files.push(file);
    },

    handleFileUploaded(event) {
      const files = [event];
      files.forEach(file => this.uploadedFiles.push(file.files));
      this.$emit('file:uploaded', event);
    }
  },

  watch: {
    uploadProgressData(newValue) {
      const isEmptyObject = !Object.keys(newValue).length;
      const uploadInProgress = isEmptyObject ? false : true;
      
      this.$emit('file:upload-in-progress', uploadInProgress);
    }
  }
}
</script>